import { HttpService, Repository, RepositoryBase, RepositoryResponseCode, RepositorySaveResponse, SaveConflictResponse, SaveForbiddenResponse, TaggedUrl, Tags, Weaver } from '@skylab-shared/core';
import { MS_PER_MINUTE, pickBy } from '@skylab-shared/utils';
import { AxiosResponse } from 'axios';
import { IntegrationBO } from './integration.bo';
import { IntegrationGetDTO, IntegrationPostDTO } from './integration.dto';
import { IntegrationModel } from './integration.model';

@Repository({
	boType: IntegrationBO,
	apiController: TaggedUrl.join('MarketplaceAccounts', [Tags.SelloApi]),
	dto: {
		get: IntegrationGetDTO,
		update: IntegrationPostDTO
	},
	customSaveRequestTimeout: 3 * MS_PER_MINUTE
})
export class IntegrationRepositoryBase extends RepositoryBase<IntegrationBO, IntegrationModel, IntegrationGetDTO, IntegrationPostDTO> {
	public constructor(
		http: HttpService,
		private readonly weaver: Weaver
	) {
		super(http);
	}

	protected createBO(): IntegrationBO {
		return new IntegrationBO(this.weaver);
	}

	protected async fromPlainObjectAsync(data: IntegrationGetDTO): Promise<IntegrationModel> {
		const item = data.data.item;
		const model = new IntegrationModel(pickBy<IntegrationModel>({
			accountGuid: item.accountGuid,
			authenticationType: item.authenticationType,
			createdDate: item.createdDate ? new Date(item.createdDate) : null,
			isActive: item.isActive,
			isConnected: item.isConnected,
			lastSyncDate: item.lastSyncDate ? new Date(item.lastSyncDate) : null,
			modifiedDate: item.modifiedDate ? new Date(item.modifiedDate) : null,
			name: item.name,
			providerAccountName: item.providerAccountName,
			providerType: item.providerType,
		}, val => val !== undefined));

		return model;
	}

	protected async preparePlainObjectAsync(model: IntegrationModel): Promise<IntegrationPostDTO> {
		return {
			name: model.name,
			providerType: model.providerType
		}
	}

	protected override prepareSaveResponse(response: AxiosResponse): RepositorySaveResponse | SaveConflictResponse<unknown> | SaveForbiddenResponse<unknown> {
		const code = this.convertResponseToResponseCode(response);

		if (code === RepositoryResponseCode.Success) {
			return { code, object: { id: response?.data?.data?.providerAccountId, version: ''} as any};
		}

		return super.prepareSaveResponse(response);
	}
}
